import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// APOLLO
import { propType } from 'graphql-anywhere';
import invoiceFragment from 'ApolloClient/Fragments/invoiceFragment';
import serverSidePaypalPayment from 'ApolloClient/Mutations/serverSidePaypalPayment';
import { graphql } from 'react-apollo';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';
import PaypalTip from 'components/common/PaypalTip';

const sandboxClientId = process.env.REACT_APP_PAYPAL_SANDBOX_CLIENT_ID; // Meteor.settings.public.config.paypalSandboxClientId;
const productionClientId = process.env.REACT_APP_PAYPAL_PRODUCTION_CLIENT_ID; // Meteor.settings.public.config.paypalProductionClientId;

const rootUrl = process.env.REACT_APP_PUBLIC_URL; //__meteor_runtime_config__.ROOT_URL; // includes end slash
const paypal = window.paypal; // https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-global-variables

// See:
// https://developer.paypal.com/docs/classic/paypal-payments-standard/integration-guide/ProfileAndTools/
// https://demo.paypal.com/us/demo/navigation?merchant=beauty&page=product
// https://github.com/paypal/paypal-checkout
// https://github.com/paypal/paypal-checkout/issues/345
// https://www.paypalobjects.com/en_AU/vhelp/paypalmanager_help/credit_card_numbers.htm
// For testing use:
// https://developer.paypal.com/demo/checkout/#/pattern/checkout
// <your-paypal-email-account>-buyer@....
// <your-paypal-email-account>-facilitator@....
class PaypalPayBtn extends React.PureComponent {
  state = {
    showPaypalTips: false,
  };

  componentDidMount() {
    const { invoice, payeeEmail, amount, currency = 'USD', serverSidePaypalPayment } = this.props;

    if (amount === 0 || amount == '0.00' || amount == '0.0' || amount == '0') {
      return;
    }

    const payment = {
      intent: 'sale',
      payer: {
        payment_method: 'paypal',
      },
      redirect_urls: {
        // return_url: `${rootUrl}paypal-return`,
        return_url: `${rootUrl}invoice/paypal-return/${invoice._id}`,
        cancel_url: `${rootUrl}invoice/paypal-canceled`,
      },
      transactions: [
        {
          item_list: {
            items: [
              {
                name: 'item',
                sku: 'item',
                price: amount,
                currency,
                quantity: 1,
              },
            ],
          },
          amount: {
            currency,
            total: amount,
          },
          payee: {
            email: payeeEmail,
          },
          description: 'This is the payment description.',
        },
      ],
    };

    // Render the button into the container element
    paypal.Button.render(
      {
        env: process.env.REACT_APP_PAYPAL_MODE === 'sandbox' ? 'sandbox' : 'production', // sandbox | production
        // Pass the client ids to use to create your transaction on sandbox and production environments
        client: {
          sandbox: sandboxClientId, // from https://developer.paypal.com/developer/applications/
          production: productionClientId, // from https://developer.paypal.com/developer/applications/
        },
        // Pass the payment details for your transaction
        // See https://developer.paypal.com/docs/api/payments/#payment_create for the expected json parameters
        payment: async (resolve, actions) => {
          let response;

          try {
            response = await actions.payment.create(payment);
          } catch (err) {
            console.log(err.message);
            this.setState({ showPaypalTips: true });
            //history.push('/invoice/paypal-canceled');
            return ErrorHelpers.handleError(err);
          }

          console.log(response);
          return response; //actions.payment.create(payment);
        },
        // Display a "Pay Now" button rather than a "Continue" button
        commit: true,
        // Pass a function to be called when the customer completes the payment
        onAuthorize: async (data, actions) => {
          try {
            await serverSidePaypalPayment({
              variables: {
                invoiceId: this.props.invoice._id,
                paymentID: data.paymentID,
                payerID: data.payerID,
                paymentToken: data.paymentToken,
              },
            });
          } catch (err) {
            console.log(err);
            this.setState({ showPaypalTips: true });
            window.location.reload();
            return ErrorHelpers.handleError(err);
          }
          window.location.reload();
        },
        // Pass a function to be called when the customer cancels the payment
        onCancel(data) {
          // console.log('The payment was cancelled!', data);
          window.location.reload();
        },
      },
      '#paypalBtn',
    );
  }

  render() {
    return (
      <div>
        <div id="paypalBtn" />
        {this.state.showPaypalTips && (
          <div style={{ padding: 10 }}>
            <PaypalTip />
          </div>
        )}
      </div>
    );
  }
}

PaypalPayBtn.propTypes = {
  invoice: propType(invoiceFragment).isRequired,
  payeeEmail: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default graphql(serverSidePaypalPayment, { name: 'serverSidePaypalPayment' })(withRouter(PaypalPayBtn));



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaypalPayBtn/index.js